import React from "react";
import styled from "styled-components";

const Cirlce = styled.circle`
  fill: ${props =>
    props.secondary ? props.theme.closeRed : props.theme.mapPopupClose};
`;

const CloseIcon = ({ big, thin, secondary, ...props }) => {
  if (big) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="32.541"
        height="32.541"
        viewBox="0 0 32.541 32.541"
      >
        <g transform="translate(0 0)">
          <circle cx="16.27" cy="16.27" r="16.27" fill="#e26a71" />
          <g transform="translate(9.512 9.512)">
            <line
              x1="14.018"
              y1="14.018"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
          </g>
          <line
            y1="14.018"
            x2="14.018"
            transform="translate(9.512 9.512)"
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
        </g>
      </svg>
    );
  } else if (thin) {
    return window.innerWidth > 1800 ? (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <path d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#6678d1" />
        <g
          transform="translate(9.171 8.745)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        >
          <line x2="11.658" y2="11.658" />
          <line x1="11.658" y2="11.658" />
        </g>
      </svg>
    ) : (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20.007"
        height="20.007"
        viewBox="0 0 20.007 20.007"
      >
        <Cirlce secondary={secondary} cx="10.004" cy="10.004" r="10.004" />
        <g
          transform="translate(5.852 5.547)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
        >
          <line x2="8.303" y2="8.303" />
          <line x1="8.303" y2="8.303" />
        </g>
      </svg>
    );
  } else
    return window.innerWidth > 1800 ? (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
      >
        <g transform="translate(-1761 -55)">
          <circle
            cx="15"
            cy="15"
            r="15"
            transform="translate(1761 55)"
            fill="#e26a71"
          />
          <g transform="translate(1769 63.843)">
            <line
              x1="13.032"
              y1="13.032"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              y1="13.032"
              x2="13.032"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        {...props}
      >
        <g transform="translate(-1144 -35.5)">
          <circle
            cx="10"
            cy="10"
            r="10"
            transform="translate(1144 35.5)"
            fill={secondary ? "#6678D1" : "#e26a71"}
          />
          <g transform="translate(1149 40.5)">
            <line
              x1="10"
              y1="10"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              y1="10"
              x2="10"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
        </g>
      </svg>
    );
};

export default CloseIcon;
